import glamorous from "glamorous";

export const Container = glamorous.div({
  marginTop: "10px",
  marginLeft: "0px",
  marginBottom: "10px",
  padding: "0",
  display: "inline-block",
  position: "relative",
  backgroundColor: "rgb(255, 255, 255)",
  width: "calc(100% - 40px)",
  boxSizing: "border-box",
  verticalAlign: "top",
  "@media screen and (min-width: 992px)": {
    marginRight: "10px",
    marginLeft: "0px",
    marginBottom: "20px",
    width: "calc(50% - 20px)",
  },
});

export const Header = glamorous.div({
  margin: "0",
  padding: "10px",
  height: "47px",
  boxSizing: "border-box",
  backgroundColor: "rgb(229, 230, 230)",
  "@media screen and (min-width: 992px)": {},
});

export const HeaderTitle = glamorous.span({
  position: "relative",
  display: "block",
  fontSize: "20px",
  lineHeight: "26px",
  fontFamily: "jd_sans_promedium",
  "@media screen and (min-width: 992px)": {},
});

export const BillingReadOnly = glamorous.div({
  paddingTop: "20px",
  paddingBottom: "0px",
  backgroundColor: "rgb(244, 243, 243)",
  textAlign: "left",
  lineHeight: "26px",
  "@media screen and (min-width: 992px)": {},
});

export const ReadOnlySpan = glamorous.span({
  paddingLeft: "20px",
  paddingTop: "10px",
  paddingBottom: "10px",
  "@media screen and (min-width: 992px)": {},
});
